import type React from 'react'
import { useMemo } from 'react'

export type Refs<T> = Array<React.MutableRefObject<T> | React.LegacyRef<T> | undefined>

function mergeRefs<T = any>(refs: Refs<T>): React.RefCallback<T> {
    return (value) => {
        refs.filter(Boolean).forEach((ref) => {
            if (typeof ref === 'function') {
                ref(value)
            } else if (ref != null) {
                // eslint-disable-next-line no-param-reassign
                ;(ref as React.MutableRefObject<T | null>).current = value
            }
        })
    }
}

function useMergeRefs<T = any>(refs: Refs<T>) {
    return useMemo(() => {
        return mergeRefs(refs)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs)
}

export { mergeRefs, useMergeRefs }
